import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import ErrorIcon from "@material-ui/icons/Error";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from '@material-ui/icons/Done';

class MultiSnack extends React.Component {
  constructor(props) {
    super(props);
    this.messages = [];
    this.state = {
      open: false,
      message: {}
    };
  }

  //componen; Estaba colgado, No hace nada..

  UNSAFE_componentWillReceiveProps = ({ message }) => {
    if (message) this.addMessage(message);
  };

  addMessage = msg => {
    this.messages.push(msg);

    if (this.state.open) {
      this.setState({ open: false });
    } else {
      this.processQueue();
    }
  };

  processQueue = () => {
    if (this.messages.length > 0) {
      this.setState({
        message: this.messages.shift(),
        open: true
      });
    }
  };

  handleExited = () => {
    this.processQueue();
  };

  closeMessage = () => {
    this.setState({ open: false });
  };

  clearQueue = () => {
    this.messages = [];
    this.setState({ open: false });
  };


  getVariant = () => {
    if(this.state.message.type === "success"){
      return "success"
    } else if (this.state.message.type === "none"){
      return "none"
    }else if (this.state.message.type === "warning"){
      return "warning"
    } else {
      return "error"
    }
  }

  //autoHideDuration ---- tiempo para el error generico -----

  render = () => (
    <Snackbar
      variant={this.getVariant()}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={this.state.open}
      onClose={this.closeMessage}
      //onExited={this.handleExited}
      TransitionProps={{onExited:this.handleExited()}}
      message={
        <div className="snackWrapper">
          {this.state.message.type === "success" ? <DoneIcon /> : <ErrorIcon />}
          <span id="message-id">{this.state.message.text}</span>
        </div>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={this.closeMessage}
        >
          <CloseIcon />
        </IconButton>
      ]}
    />
  );
}

export default MultiSnack;
